/**
 * UUIDv7 generation (protocol.md §2: IDs are time-ordered UUIDv7, lowercase strings). Used for
 * `cmdId` (idempotency + ack correlation) and REST `Idempotency-Key` headers. Hand-rolled to avoid a
 * dependency; uses the platform CSPRNG (`globalThis.crypto`, present in Node 22 and all browsers).
 */

function randomBytes(n: number): Uint8Array {
  const bytes = new Uint8Array(n);
  globalThis.crypto.getRandomValues(bytes);
  return bytes;
}

const HEX: string[] = Array.from({ length: 256 }, (_, i) => i.toString(16).padStart(2, '0'));

/** Generate a lowercase UUIDv7 string (RFC 9562 §5.7). */
export function uuidv7(nowMs: number = Date.now()): string {
  const bytes = randomBytes(16);

  // 48-bit big-endian Unix millisecond timestamp.
  const ms = Math.floor(nowMs);
  bytes[0] = (ms / 2 ** 40) & 0xff;
  bytes[1] = (ms / 2 ** 32) & 0xff;
  bytes[2] = (ms / 2 ** 24) & 0xff;
  bytes[3] = (ms / 2 ** 16) & 0xff;
  bytes[4] = (ms / 2 ** 8) & 0xff;
  bytes[5] = ms & 0xff;

  // Version 7 in the high nibble of byte 6; variant 10xx in the high bits of byte 8.
  bytes[6] = (bytes[6]! & 0x0f) | 0x70;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;

  const h = (i: number) => HEX[bytes[i]!];
  return (
    `${h(0)}${h(1)}${h(2)}${h(3)}-${h(4)}${h(5)}-${h(6)}${h(7)}-` +
    `${h(8)}${h(9)}-${h(10)}${h(11)}${h(12)}${h(13)}${h(14)}${h(15)}`
  );
}
